import React from "react";
import { Typography } from "@mui/material";
import { Badge } from "../../../../ui/badge";

const RecipeDiets = ({ diets }) => {
  //To DO:
  //- allergen disclaimer, always check product labels and verify ingredients for allergens
  //- if list empty, say "none listed"

  return (
    <div className="mt-4">
      <div>
        <Typography variant="subtitle1" className="text-primaryText font-sans font-normal leading-tight">
          Friendly Diets:
        </Typography>
      </div>
      <div className="my-2">
        {diets.map((diet, i) => {
          return (
            <Badge
              variant="secondary"
              className="font-normal mr-[0.25rem] mb-[0.25rem] py-1 px-3 shadow-sm cursor-pointer border-secondaryText-200"
            >
              <Typography variant="body2" className="text-xs">
                {diet.text}
              </Typography>
            </Badge>
          );
        })}
      </div>
      <div className="mb-2">
        <Typography variant="subtitle2" className="font-normal text-secondaryText text-xs leading-snug">
          Always check product labels and verify ingredients meet your personal dietary restrictions
        </Typography>
      </div>
    </div>
  );
};

export default RecipeDiets;
